import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../config";
import Loader from "../../components/Loader";
import "../Home/Home.css";
import "./forgetPassword.css";

const ForgetPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [processing, setProcessing] = useState(false);
  const navigate = useNavigate();

  const triggerResetEmail = async (e) => {
    e.preventDefault();
    setError("");
    setProcessing(true);

    try {
      await sendPasswordResetEmail(auth, email);
      setSuccess(true);
    } catch (err) {
      console.log(err);
      setError("Could not send reset email. Check the address and try again.");
    } finally {
      setProcessing(false);
    }
  };

  return (
    <div className="auth-page auth-page--centered">
      <div className="auth-panel">
        <div className="auth-card">
          <Link to="/" className="auth-back-link">
            ← Back to sign in
          </Link>

          <form onSubmit={triggerResetEmail} className="auth-form">
            <h2 className="auth-form__title">Reset password</h2>
            <p className="auth-form__subtitle">
              We&apos;ll email you a link to reset your password.
            </p>

            {success ? (
              <div className="auth-form__success">
                <p>Check your inbox for a password reset link.</p>
                <button
                  type="button"
                  className="auth-form__submit"
                  onClick={() => navigate("/")}
                >
                  Return to sign in
                </button>
              </div>
            ) : (
              <>
                <div className="auth-form__field">
                  <label htmlFor="reset-email">Email</label>
                  <input
                    id="reset-email"
                    type="email"
                    placeholder="you@company.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                {error && (
                  <p className="auth-form__error" role="alert">
                    {error}
                  </p>
                )}

                <button
                  type="submit"
                  className="auth-form__submit"
                  disabled={processing}
                >
                  {processing ? <Loader size={22} /> : "Send reset link"}
                </button>
              </>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;
